import React from 'react';
import { motion } from 'framer-motion';
import { TOKENS } from '../tokens';

export default function PropertyMoment() {
  return (
    <section style={{
      position: 'relative',
      minHeight: '100vh',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      overflow: 'hidden',
      background: '#050A1A',
    }}>
      <style>{`
        @keyframes glowPulse {
          0%,100% { transform:scale(1); opacity:0.6; }
          50%      { transform:scale(1.15); opacity:1; }
        }
      `}</style>

      {/* Ambient glow */}
      <div style={{
        position: 'absolute',
        width: 600, height: 600,
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(200,169,106,0.06) 0%, transparent 70%)',
        animation: 'glowPulse 4s ease-in-out infinite',
        pointerEvents: 'none',
      }} />

      {/* Architectural blueprint SVG */}
      <div style={{
        position: 'absolute', inset: 0,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        opacity: 0.1, pointerEvents: 'none',
      }}>
        <svg viewBox="0 0 700 500" style={{ width: 'min(700px, 90vw)', height: 'auto' }} fill="none">
          <rect x="100" y="80" width="500" height="340" stroke="#C8A96A" strokeWidth="1.5" />
          <rect x="130" y="110" width="180" height="140" stroke="#C8A96A" strokeWidth="0.8" />
          <rect x="390" y="110" width="180" height="140" stroke="#C8A96A" strokeWidth="0.8" />
          <rect x="130" y="280" width="440" height="110" stroke="#C8A96A" strokeWidth="0.8" />
          <line x1="100" y1="80" x2="60" y2="40" stroke="#C8A96A" strokeWidth="0.5" strokeDasharray="4 4" />
          <line x1="600" y1="80" x2="640" y2="40" stroke="#C8A96A" strokeWidth="0.5" strokeDasharray="4 4" />
          <line x1="60" y1="40" x2="640" y2="40" stroke="#C8A96A" strokeWidth="0.5" />
          <text x="350" y="35" textAnchor="middle" fill="#C8A96A" fontSize="12" fontFamily="monospace">15.03m</text>
          <line x1="60" y1="80" x2="60" y2="420" stroke="#C8A96A" strokeWidth="0.5" />
          <text x="40" y="260" textAnchor="middle" fill="#C8A96A" fontSize="12" fontFamily="monospace" transform="rotate(-90 40 260)">11.25m</text>
          <circle cx="220" cy="180" r="2" fill="#C8A96A" />
          <circle cx="480" cy="180" r="2" fill="#C8A96A" />
          <text x="350" y="340" textAnchor="middle" fill="#C8A96A" fontSize="10" fontFamily="monospace" opacity="0.6">MAIN FLOOR PLAN · SCALE 1:100</text>
        </svg>
      </div>

      {/* Content */}
      <motion.div
        initial={{ opacity: 0, scale: 0.94 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
        style={{ position: 'relative', zIndex: 2, textAlign: 'center', padding: '0 32px' }}
      >
        <motion.span
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1], delay: 0.1 }}
          style={{
            display: 'block',
            fontFamily: "'Cormorant Garamond', serif",
            fontSize: 'clamp(8rem, 20vw, 16rem)',
            fontWeight: 300, lineHeight: 0.9,
            letterSpacing: '-0.03em',
            color: 'transparent',
            WebkitTextStroke: '1px rgba(200,169,106,0.28)',
            marginBottom: -16,
          }}
        >
          225
        </motion.span>

        <motion.span
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.25 }}
          style={{
            display: 'block',
            fontSize: '0.68rem', fontWeight: 500,
            letterSpacing: '0.25em', textTransform: 'uppercase',
            color: TOKENS.GOLD, marginBottom: 28,
          }}
        >
          Square Yards · Commercial Ground Floor
        </motion.span>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.4 }}
          style={{
            fontSize: 'clamp(1rem, 2vw, 1.25rem)',
            fontWeight: 300, lineHeight: 1.65,
            color: 'rgba(255,255,255,0.65)',
          }}
        >
          <strong style={{ color: '#fff', fontWeight: 400 }}>Industrial. Commercial.</strong><br />
          A blank canvas in a location that does the selling itself.<br />
          Jhandewalan, Central Delhi — where scarcity meets demand.
        </motion.p>
      </motion.div>
    </section>
  );
}
